import { Sprite, useApp } from "@pixi/react"
import { memo } from "react"
import {
  BADGE_BG_COLOR,
  BADGE_BORDER_COLOR,
  BADGE_PADDING_X,
  BADGE_PADDING_Y,
  badgeFontStyle
} from "@/domains/visualization/constants/graph"
import { useTextBoxTexture } from "@/domains/visualization/hooks/useTextBoxTexture/useTextBoxTexture"

interface NodeLabelBadgeProps {
  label: string
  x: number
  y: number
}

export const NodeLabelBadge = memo(function NodeLabelBadge({ label, x, y }: NodeLabelBadgeProps) {
  const app = useApp()

  const textBoxTextureOptions = {
    title: label,
    app,
    fontStyle: badgeFontStyle,
    backgroundColor: BADGE_BG_COLOR,
    textColor: badgeFontStyle.fill,
    borderRadius: 999,
    borderColor: BADGE_BORDER_COLOR,
    borderAlpha: 1,
    borderWidth: 1,
    paddingX: BADGE_PADDING_X,
    paddingY: BADGE_PADDING_Y
  }

  const { texture, scale } = useTextBoxTexture(textBoxTextureOptions)

  return texture ? (
    <Sprite texture={texture} scale={scale} x={x - texture.width * scale} y={y - (texture.height * scale) / 2} />
  ) : null
})
